import * as React from 'react';
import cx from 'classnames';
import { observer } from 'mobx-react';
import useStore from '@src/utils/hooks/use-store';
import Link from '@src/components/link';
import Page from '../../components/page';
import Store from './store';

const styles = require('./index.less');

const Container = () => {
  const store = useStore(() => new Store());

  return (
    <Page className={styles.root}>
      <div className={styles['canvas']} style={{ top: 40 }}>
        {/*  bg: 背景  */}
        <div className={styles['bg']} role="img" aria-label="背景" />
        <div className={cx(styles['aside-nav'], store.isShowAsideNav && styles.isShowAsideNav)}>
          {/*  aside-nav-line: aside-导航线条  */}
          <div className={styles['aside-nav-line']} role="img" aria-label="aside-导航线条" />
          {/*  nav-list: 导航列表  */}
          <div className={styles['nav-list']}>
            {store.asideNavList.map((item, idx) => (
              <Link
                key={idx}
                onClick={() => store.clickNavItem(item)}
                hoverEffect="zoom"
                data-anchor={item.anchor}
                className={styles[store.isActiveNav(item.tag) ? `nav-item-${idx + 1}-active` : `nav-item-${idx + 1}`]}
                aria-label={item.name}
              />
            ))}
          </div>
          {/*  btn-back-top: 按钮返回顶部  */}
          <Link hoverEffect="zoom" onClick={() => store.backtop()} className={styles['btn-back-top']} role="img" aria-label="按钮返回顶部" />
          {/*  btn-back-home: 按钮返回-home  */}
          <Link hoverEffect="zoom" onClick={() => store.redirect('/')} className={styles['btn-back-home']} role="img" aria-label="按钮返回-home" />
        </div>
        {/*  section-kv: 区域-kv  */}
        <div className={styles['section-kv']}>
          {/*  logo  */}
          <Link href={store.gameIndexUrl} target={'_blank'} className={styles['logo']} aria-label="logo" />
          {/*  btn-to-official: 按钮-official  */}
          <Link onClick={store.toOfficial} hoverEffect="zoom" target={'_blank'} className={styles['btn-to-official']} aria-label="按钮-official" />
          {/*  btn-download: 按钮下载  */}
          <Link onClick={store.downloadGame} hoverEffect="zoom" target={'_blank'} className={styles['btn-download']} aria-label="按钮下载" />
          {/*  scroll-down-tip: scroll-down-提示  */}
          <div className={styles['scroll-down-tip']} role="img" aria-label="scroll-down-提示" />
        </div>
        {/*  section-1: 区域-1  */}
        <div id="section-1" className={styles['section-1']}>
          {/*  s1-title: s1-标题  */}
          <div className={styles['s1-title']} role="img" aria-label="s1-标题" />
          {/*  s1-frame: s1-框架  */}
          <div className={styles['s1-frame']}>
            <div className={styles.content} dangerouslySetInnerHTML={{ __html: store.cmsData?.[11504] }} />
          </div>
          {/*  s1-subtitle: s1-副标题  */}
          <div className={styles['s1-subtitle']} role="img" aria-label="s1-副标题" />
        </div>
        {/*  section-5: 区域-5  */}
        <div id="section-5" className={styles['section-5']}>
          {/*  s5-title: s5-标题  */}
          <div className={styles['s5-title']} role="img" aria-label="s5-标题" />
          {/*  s5-frame: s5-框架  */}
          <div className={styles['s5-frame']}>
            <div
              className={styles.content}
              dangerouslySetInnerHTML={{ __html: store.cmsData?.[store.tabsList.section5[store.tabsList.section5ActiveIndex].cmsId] }}
            />
          </div>
          {/*  s5-subtitle: s5-副标题  */}
          <div className={styles['s5-subtitle']} />
          {/* <div className={styles['s5-subtitle']} style={{ backgroundImage: `url(${store.tabsList.section5[store.tabsList.section5ActiveIndex].subtitle})` }} /> */}
          {/*  s5-tab: s5-选项卡  */}
          {/* <div className={styles['s5-tab']}>
            {store.tabsList.section5.map((item, idx) => (
              <Link
                hoverEffect="zoom"
                key={idx}
                onClick={() => store.clickTab('section5', idx)}
                className={styles['tab-item']}
                style={{ backgroundImage: `url(${store.tabsList.section5ActiveIndex === idx ? item.tabActive : item.tab})` }}
              />
            ))}
          </div> */}
        </div>
        {/*  section-2: 区域-2  */}
        <div id="section-2" className={styles['section-2']}>
          {/*  s2-title: s2-标题  */}
          <div className={styles['s2-title']} role="img" aria-label="s2-标题" />
          {/*  s2-tab: s2-选项卡  */}
          <div className={styles['s2-tab']}>
            {store.tabsList.section2.map((item, idx) => (
              <Link
                hoverEffect="zoom"
                key={idx}
                onClick={() => store.clickTab('section2', idx)}
                className={styles['tab-item']}
                style={{ backgroundImage: `url(${store.tabsList.section2ActiveIndex === idx ? item.tabActive : item.tab})` }}
              />
            ))}
          </div>
          {/*  s2-frame: s2-框架  */}
          <div className={styles['s2-frame']}>
            <div
              className={styles.content}
              dangerouslySetInnerHTML={{ __html: store.cmsData?.[store.tabsList.section2[store.tabsList.section2ActiveIndex].cmsId] }}
            />
          </div>
          {/*  s2-subtitle-1: s2-副标题-1  */}
          <div
            className={styles['s2-subtitle-1']}
            style={{ backgroundImage: `url(${store.tabsList.section2[store.tabsList.section2ActiveIndex].subtitle})` }}
          />
        </div>
        {/*  section-3: 区域-3  */}
        <div id="section-3" className={styles['section-3']}>
          {/*  s3-title: s3-标题  */}
          <div className={styles['s3-title']} role="img" aria-label="s3-标题" />
          {/*  s3-frame: s3-框架  */}
          <div className={styles['s3-frame']}>
            <div
              className={styles.content}
              dangerouslySetInnerHTML={{ __html: store.cmsData?.[store.tabsList.section3[store.tabsList.section3ActiveIndex].cmsId] }}
            />
          </div>
          {/*  s3-subtitle-1: s3-副标题-1  */}
          <div
            className={styles['s3-subtitle-1']}
            style={{ backgroundImage: `url(${store.tabsList.section3[store.tabsList.section3ActiveIndex].subtitle})` }}
          />
          {/*  s3-tab: s3-选项卡  */}
          <div className={styles['s3-tab']}>
            {store.tabsList.section3.map((item, idx) => (
              <Link
                hoverEffect="zoom"
                key={idx}
                onClick={() => store.clickTab('section3', idx)}
                className={styles['tab-item']}
                style={{ backgroundImage: `url(${store.tabsList.section3ActiveIndex === idx ? item.tabActive : item.tab})` }}
              />
            ))}
          </div>
        </div>
        {/*  section-4: 区域-4  */}
        <div id="section-4" className={styles['section-4']}>
          {/*  s4-title: s4-标题  */}
          <div className={styles['s4-title']} role="img" aria-label="s4-标题" />
          {/*  s4-frame: s4-框架  */}
          <div className={styles['s4-frame']}>
            <div className={styles.content} dangerouslySetInnerHTML={{ __html: store.cmsData?.[11518] }} />
          </div>
          {/*  s4-subtitle: s4-副标题  */}
          <div className={styles['s4-subtitle']} role="img" aria-label="s4-副标题" />
        </div>
      </div>
    </Page>
  );
};

export default observer(Container);
